import React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import Typography from '../common/Typography'

const ReviewChart = ({ data }) => {
  // Process the API data to match the chart format
  const processChartData = (apiData) => {
    if (!apiData?.data?.overall?.chartData?.reviewChart) {
      // Fallback data if no API data available
      return [
        { rating: '5', percentage: 88 },
        { rating: '4', percentage: 32 },
        { rating: '3', percentage: 21 },
        { rating: '2', percentage: 18 },
        { rating: '1', percentage: 12 },
      ]
    }

    const reviewData = apiData.data.overall.chartData.reviewChart
    
    // Create a complete rating structure (0-5 stars with 0.1 increments)
    const completeRatings = {}
    
    // Generate all possible ratings from 0.0 to 5.0 with 0.1 increments
    for (let i = 0; i <= 50; i++) {
      const rating = (i / 10).toFixed(1)
      completeRatings[rating] = { count: 0, percentage: 0 }
    }

    // Function to round rating to nearest 0.1
    const roundToNearestTenth = (rating) => {
      return Math.round(rating * 10) / 10
    }

    // Fill in the actual data from API
    reviewData.forEach(item => {
      const roundedRating = roundToNearestTenth(item.rating).toFixed(1)
      if (completeRatings[roundedRating]) {
        completeRatings[roundedRating].count += item.count
        completeRatings[roundedRating].percentage += item.percentage
      }
    })

    // Convert to chart format and sort by rating (highest first)
    return Object.entries(completeRatings)
      .map(([rating, data]) => ({
        rating: rating,
        percentage: data.percentage,
        count: data.count
      }))
      .filter(item => item.percentage > 0) // Only show ratings that have data
      .sort((a, b) => parseFloat(b.rating) - parseFloat(a.rating)) // Sort descending (5.0 to 0.0)
  }

  const chartData = processChartData(data)

  return (
    <div className="w-full h-full">
      {/* <h3 className="text-lg font-semibold text-gray-800 mb-4">Review</h3> */}
      <div className="text-sm font-semibold text-gray-800 mt-2">
        <span>Total number of review</span>
        {data?.data?.overall?.summary?.totalReviews && (
          <span className="ml-1">: {data.data.overall.summary.totalReviews}
          </span>
        )}
      </div>
      <div className="relative">
        <ResponsiveContainer width="100%" height={250}>
          <BarChart 
            data={chartData} 
            layout="vertical" 
            margin={{ top: 20, right: 60, left: 20, bottom: 5 }}
          >
            <XAxis 
              type="number" 
              domain={[0, 100]} 
              hide
            />
            <YAxis 
              type="category" 
              dataKey="rating" 
              axisLine={false} 
              tickLine={false} 
              width={30}
              tickFormatter={value => `${value}`}
            />
            <Tooltip
              cursor={{ fill: 'rgba(0, 0, 0, 0.05)' }}
              contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
              labelStyle={{ fontWeight: 'bold', color: '#333' }}
              itemStyle={{ color: '#555' }}
              formatter={(value, name, props) => [
                `${value}% (${props.payload.count} reviews)`, 
                'Percentage'
              ]}
              labelFormatter={(value) => `${value} Star Rating`}
            />
            <Bar 
              dataKey="percentage" 
              fill="#FF8C00" 
              background={{ fill: 'rgba(255, 140, 0, 0.1)' }} 
              barSize={30} 
            />
          </BarChart>
        </ResponsiveContainer>
        
        {/* Percentage labels on the right */}
        <div className="absolute right-0 top-0 h-full flex flex-col justify-center">
          {chartData.map((item, index) => (
            <div 
              key={item.rating} 
              className="flex items-center justify-end text-sm font-medium text-gray-700"
              style={{ 
                height: '40px', 
                marginTop: index === 0 ? '20px' : '0',
                marginBottom: index === chartData.length - 1 ? '5px' : '0'
              }}
            >
              {item.percentage}%
            </div>
          ))}
        </div>
      </div>
      
      
    </div>
  )
}

export default ReviewChart